import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from "gatsby";
import { generateSlug } from '../../lib/functions/util-functions';
import Image from '../../components/image/image';

/**
 * CMS Component: DatoCmsComponentImage
 * 
 */
const ImageLayout = ({data, className, ...other}) => {
  const {images, layout} = data || {};
  return (
    <div className={`imageLayout ${className || ''} imageLayout--${generateSlug(layout)}`} {...other} >
      {
        images.length > 0 && 
        images.map((row, i)=>{
          return <Image caption={(layout === '100' ||  layout === '100 full height' || layout === 'Default') ? true : false} data={row} key={i} />
        }
        )
      }
    </div>
  );
};

ImageLayout.propTypes = {
  /**
  * Data from cms
  */
  data: PropTypes.shape({
    images: PropTypes.array,
    layout: PropTypes.oneOf([
      'Default', '100', '100-full-height', 
      '50/50', '33/66', '66/33',
      '70/30', '65/35', '35/65', 
      '45/55', '55/45', '100/40',
      '100/50', '100/60', '80/40', 
      '80/50', '75/25', '40/60',
      '60/40','75/25centre'
    ]),
  }),
  className: PropTypes.string,
};

export default ImageLayout;

export const ImageLayoutFragment = graphql`
fragment ImageLayoutFragment on DatoCmsComponentImage {
   
  id: originalId
  images{
    ...ContainerImageFragment
  }
  layout
}
`;